import React from "react";
import RolesContainer from "@commr/admin/components/roles/rolesContainer";
import { Residency } from "@commr/admin/models/residency/residency";

const RolesPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <RolesContainer residency={new Residency()} />
);

export default RolesPage;
